'use es6';

import Ticket from 'customer-data-objects/ticket/TicketRecord';
import PropTypes from 'prop-types';
const TicketType = PropTypes.instanceOf(Ticket);
export default TicketType;